<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <v-select
    v-model="internalValue"
    :dense="dense"
    :hide-details="hideDetails"
    :items="timeArrays"
    :label="$t(label)"
    :menu-props="{offsetY:true}"
    :rules="rules"
    item-text="start"
    item-value="start"
    outlined
  />
</template>

<script>
import { timeArrays } from '@/model/dataLayer/api/common/OpenTimeList'

export default {
  name: 'TimeSelector',
  props: {
    value: {},
    dense: {},
    hideDetails: {},
    label: {},
    rules: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      internalValue: null
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler () {
        this.internalValue = this.value
      }
    },
    internalValue () {
      this.$emit('input', this.internalValue)
    }
  },
  computed: {
    timeArrays () {
      return timeArrays
    }

  }

}
</script>

<style scoped>

</style>
